import React from 'react';
import PropTypes from 'prop-types';

const FormPage = props => {
  const { currentPage, page, children } = props;
  if (currentPage !== page) return null;

  return children;
};

export default FormPage;
